export default __webpack_public_path__ + "static/media/FG_26.344496ec.jpg";